import { IComposableDashboardCollection } from '.';

const defaultComposableDashboardCollection: IComposableDashboardCollection = {
  name: '',
  dashboardIds: [],
  createdBy: '',
  createdByName: '',
  workspaceId: '',
  id: '',
  accessLevel: '',
  sharedWithRecruiters: [],
  sharedWithTeams: [],
  sharedWithRoles: [],
  createdOn: '',
  modifiedBy: '',
  modifiedOn: '',
  modifiedByName: '',
  description: '',
  dashboards: [],
};

export default defaultComposableDashboardCollection;
